/**
 * Every value of an hour (or a text), grouped like the Flow Optimizer — one line per
 * category, led by a colored pill, each value in its category's hue (profit
 * and ROI by sign, zeros dimmed) so a family reads at a glance.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { FLOW_FORMULA_METRICS } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { CATEGORY_LABEL, formatMetric } from '../formula/hour-metric-catalog';
import { categoryTone, valueTone } from './value-tones';

const CATEGORIES = [...new Set(FLOW_FORMULA_METRICS.map((m) => m.category))];

export const HourAllValues: FC<{ bag: Record<string, number> }> = ({ bag }) => (
  <div className="grid grid-cols-[6.5rem_minmax(0,1fr)] items-start gap-x-3 gap-y-2 text-xs">
    {CATEGORIES.map((cat) => {
      const items = FLOW_FORMULA_METRICS.filter((m) => m.category === cat && typeof bag[m.id] === 'number');
      if (items.length === 0) return null;
      return [
        <span key={`${cat}-l`} className={cn('inline-flex items-center gap-1.5 justify-self-start rounded-md px-1.5 py-0.5 text-[11px] font-medium', categoryTone(cat).pill)}>
          <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden />
          {CATEGORY_LABEL[cat] ?? cat}
        </span>,
        <div key={`${cat}-v`} className="flex flex-wrap gap-x-4 gap-y-1 pt-0.5">
          {items.map((m) => (
            <span key={m.id} className="inline-flex items-baseline gap-1.5">
              <span className="text-muted-foreground">{m.name}</span>
              <span className={cn('font-mono font-medium tabular-nums', valueTone(cat, m.id, bag[m.id]))}>{formatMetric(m.id, bag[m.id])}</span>
            </span>
          ))}
        </div>,
      ];
    })}
  </div>
);
